import * as React from 'react';
import { useState } from 'react';
import { Menu, MenuItem, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IRoute } from '../../config/appRoutes';
import { TranslationKeys } from './AppNavList';
import { ROUTES_NS } from '../../routes/i18n';

interface MobileMenuProps {
  appRoutes: IRoute[];
}

const MobileMenu: React.FC<MobileMenuProps> = ({ appRoutes }) => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const { palette } = useTheme();
  const { t } = useTranslation(ROUTES_NS);
  const searchQuery = window.location.search;

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
      {/* Menu Icon Button */}
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>

      {/* Menu for Mobile Navigation */}
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        {appRoutes.map((route, index) => (
          <MenuItem key={index} sx={{ padding: 0 }}>
            <NavLink
              to={`${route.path}${searchQuery}`}
              style={({ isActive }) => ({
                display: 'block',
                width: '100%',
                padding: '8px 16px',
                color: isActive ? palette.text.primary : palette.text.secondary,
                textDecoration: 'none',
                borderBottom: isActive ? '1px solid #1D82C0' : 'none',
              })}
              onClick={handleCloseNavMenu}
            >
              {t(route.labelKey as TranslationKeys)}
            </NavLink>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MobileMenu;
